import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { AddressGeocodeModel } from "@/api/AddressLookup";

export type GetAddressGeocodesRequest = {
  addressLine1: string;
  unitNumber: string;
  houseNumber: string;
  streetName: string;
  suburb: string;
  postcode: string;
  city: string;
  state: string;
  country: string;
  latitude: number;
  longitude: number;
};

export type GetAddressGeocodesResponse = {
  geocode: AddressGeocodeModel | null;
};

export const getAddressGeocode = async (request: GetAddressGeocodesRequest): Promise<GetAddressGeocodesResponse> => {
  const url = "/addressgeocode";
  const response = await executeApiRequest(
    () => axios.get<GetAddressGeocodesResponse>(url, { params: request }),
    false
  );
  return response?.data;
};
